import { ILink } from "../../interfaces/Link";
import styles from "./styles.module.scss";

export function LinkAtom(props: Readonly<ILink>) {
  let className = styles.link;
  if (props.selected) className += ` ${styles.link__selected}`;

  const target = props.newWindow ? "_blank" : undefined;

  return (
    <a
      onClick={props.onClick}
      target={target}
      className={className}
      href={props.href}
      lang={props.lang}
      title={props.title}
    >
      {props.text}
    </a>
  );
}
